<template>
  <div class="widget-long-form">
    <header>
      <img v-if="hasLogo" ref="image" class="logo" :src="$store.functions.charity.displayLogo(charityId)">
      <h1 v-if="!hasLogo" class="logo">{{ charityName }} </h1>
      <p v-if="charityName">In Partnership with:</p>
      <img class="chc-logo" src="static/chc-logo.png" alt="Cars Helping Charities">
    </header>
    <section class="wrapper add-new-vehicle" v-if="state === 'form'">
      <p>Thank you for your interest! Please complete the vehicle donation form below.</p>
      <form method="POST">

        <h2 class="tab-heading">Donor Information</h2>
        <div class="tabbed-content">
          <div class="columns">
            <div class="col">
              <chc-input v-model="data.first_name" :error="errors.first_name" label="First Name" :required="true"></chc-input>
              <chc-input v-model="data.last_name" :error="errors.last_name" label="Last Name" :required="true"></chc-input>
              <chc-input v-model="data.home_phone" :error="errors.home_phone" label="Home Phone Number"></chc-input>
              <chc-input v-model="data.work_phone" :error="errors.work_phone" label="Work Phone Number"></chc-input>
              <chc-input v-model="data.mobile_phone" :error="errors.mobile_phone" label="Mobile Phone Number"></chc-input>
              <chc-input v-model="data.email" :error="errors.email" label="Email Address"></chc-input>
              <chc-input v-model="data.ssn_tax_id" :error="errors.ssn_tax_id" label="Social Security Number / Tax ID"></chc-input>
            </div>
            <div class="col">
              <chc-input v-model="data.address_street" :error="errors.address_street" label="Street Address"></chc-input>
              <chc-input v-model="data.address_city" :error="errors.address_city" label="City"></chc-input>
              <chc-input v-model="data.address_state" :error="errors.address_state" label="State" format="combo"
                         :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
              <chc-input v-model="data.address_zip" :error="errors.address_zip" label="Zip" format="zip"></chc-input>
              <chc-input v-model="data.year_of_birth" :error="errors.year_of_birth" label="Year of Birth"></chc-input>
              <chc-input v-model="data.charity_id" :error="errors.charity_id" label="Select Charity"
                         @input="loadSources"
                         :autoCompleteValues="$store.state.summary.charities" format="combo" :disabled="data.token != null" ref="charityCombo"></chc-input>
              <chc-input v-model="data.referral_source_id" :error="errors.referral_source_id" label="Referral Source"
                   :loading="isLoadingSources" :disabled="sources.length === 0"
                   :autoCompleteValues="sources" format="combo"></chc-input>
            </div>
          </div>
        </div>

        <h2 class="tab-heading">Vehicle Information</h2>
        <div class="tabbed-content">
          <div class="columns">
            <div class="col">
              <chc-input v-model="data.donation_type" :error="errors.donation_type" label="Donation Type" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.donation_type"></chc-input>
              <chc-input v-model="data.vin" :error="errors.vin" label="VIN"
                         @blur="pullVin"></chc-input>
              <chc-input v-model="data.drivable" :error="errors.drivable" label="Drivable" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.drivable"></chc-input>
              <chc-input v-model="data.vehicle_year" :error="errors.vehicle_year" :isLoading="loadingVin" label="Vehicle Year" ref="vehicleYear"></chc-input>
              <chc-input v-model="data.vehicle_make" :error="errors.vehicle_make" :isLoading="loadingVin" label="Vehicle Make" ref="vehicleMake"></chc-input>
              <chc-input v-model="data.vehicle_model" :error="errors.vehicle_model" :isLoading="loadingVin" label="Vehicle Model" ref="vehicleModel"></chc-input>
              <chc-input v-model="data.vehicle_color" :error="errors.vehicle_color" :isLoading="loadingVin" label="Color" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.color" ref="vehicleColor"></chc-input>
              <chc-input v-model="data.mileage" :error="errors.mileage" label="Mileage"></chc-input>
              <chc-input v-model="data.tire_condition" :error="errors.tire_condition" label="Tire Condition" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.tire_condition"></chc-input>
              <chc-input v-model="data.transmission_type" :error="errors.transmission_type" label="Transmission Type" format="combo"
                         :isLoading="loadingVin" ref="transmissionType"
                         :autoCompleteValues="$store.state.constants.vehicle.transmission_type"></chc-input>
              <chc-input v-model="data.drive_train" :error="errors.drive_train" label="Drive Train" format="combo"
                         :isLoading="loadingVin" ref="driveTrain"
                         :autoCompleteValues="$store.state.constants.vehicle.drive_train"></chc-input>
              <chc-input v-model="data.running" :error="errors.running" label="Running" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.running"></chc-input>
              <chc-input v-model="data.battery_and_key_or_keyfob_available" :error="errors.battery_and_key_or_keyfob_available" label="Vehicle's battery works and key or keyfob is available?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.battery_and_key_or_keyfob_available"></chc-input>

              <chc-input v-model="data.all_tires_inflated" :error="errors.all_tires_inflated" label="All tires inflated?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.all_tires_inflated"></chc-input>
              <chc-multiselect-input
                v-if="data.all_tires_inflated === 0"
                placeholder="Location of flat tires"
                fieldLabel="Location of flat tires"
                v-model="data.flat_tires_location"
                track-by="value"
                label="label"
                :options="$store.state.constants.vehicle.flat_tires_location"
                :multiple="true"
                :error="errors.flat_tires_location"
                :allow-empty="false"
                :hide-selected="false"
                :close-on-select="false"
              />

              <chc-input v-model="data.wheels_removed" :error="errors.wheels_removed" label="Vehicle has one or more wheels that are removed?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.wheels_removed"></chc-input>
              <chc-multiselect-input
                v-if="data.wheels_removed === 1"
                placeholder="Location of removed wheels"
                fieldLabel="Location of removed wheels"
                v-model="data.wheels_removed_location"
                track-by="value"
                label="label"
                :error="errors.wheels_removed_location"
                :options="$store.state.constants.vehicle.wheels_removed_location"
                :multiple="true"
                :allow-empty="false"
                :hide-selected="false"
                :close-on-select="false"
              />

              <chc-input v-model="data.body_panels_intact" :error="errors.body_panels_intact" label="Vehicle's body panels are intact?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.body_panels_intact"></chc-input>
              <chc-multiselect-input
                v-if="data.body_panels_intact === 0"
                placeholder="Location of body panel damage"
                fieldLabel="Location of body panel damage"
                v-model="data.body_panels_damage_location"
                track-by="value"
                label="label"
                :options="$store.state.constants.vehicle.body_panels_damage_location"
                :multiple="true"
                :error="errors.body_panels_damage_location"
                :allow-empty="false"
                :hide-selected="false"
                :close-on-select="false"
              />

              <chc-input v-model="data.body_damage_free" :error="errors.body_damage_free" label="Body is free of damage larger than size of baseball?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.body_damage_free"></chc-input>
              <chc-multiselect-input
                v-if="data.body_damage_free === 0"
                placeholder="Location of body damage"
                fieldLabel="Location of body damage"
                v-model="data.body_damage_location"
                track-by="value"
                label="label"
                :options="$store.state.constants.vehicle.body_damage_location"
                :multiple="true"
                :error="errors.body_damage_location"
                :allow-empty="false"
                :hide-selected="false"
                :close-on-select="false"
              />

              <chc-input v-model="data.mirrors_lights_glass_intact" :error="errors.mirrors_lights_glass_intact" label="Vehicle's mirrors, lights, and glass are intact?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.mirrors_lights_glass_intact"></chc-input>
              <chc-multiselect-input
                v-if="data.mirrors_lights_glass_intact === 0"
                placeholder="Location of mirrors, lights, and/or glass damage"
                fieldLabel="Location of mirrors, lights, and/or glass damage"
                v-model="data.mirrors_lights_glass_damage_location"
                track-by="value"
                label="label"
                :options="$store.state.constants.vehicle.mirrors_lights_glass_damage_location"
                :multiple="true"
                :error="errors.mirrors_lights_glass_damage_location"
                :allow-empty="false"
                :hide-selected="false"
                :close-on-select="false"
              />
            </div>
            <div class="col">
              <chc-input v-model="data.mechanical_condition" :error="errors.mechanical_condition" label="Mechanical Condition" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.mechanical_condition"></chc-input>
              <chc-input v-model="data.body_class" :error="errors.body_class" label="Body Class" :isLoading="loadingVin" ref="bodyClass"></chc-input>
              <chc-input v-model="data.doors" :error="errors.doors" label="Number of Doors" format="combo"
                     :isLoading="loadingVin" ref="numDoors"
                     :autoCompleteValues="$store.state.constants.vehicle.doors"></chc-input>
              <chc-input v-model="data.body_condition" :error="errors.body_condition" label="Body Condition" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.body_condition"></chc-input>
              <chc-input v-model="data.rust_condition" :error="errors.rust_condition" label="Rust Condition" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.rust_condition"></chc-input>
              <chc-input v-model="data.paint_condition" :error="errors.paint_condition" label="Paint Condition" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.paint_condition"></chc-input>
              <chc-input v-model="data.interior_condition" :error="errors.interior_condition" label="Interior Condition" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.interior_condition"></chc-input>
              <chc-input v-model="data.missing_parts" :error="errors.missing_parts" label="Missing Parts"></chc-input>
              <chc-input v-model="data.other_conditions" :error="errors.other_conditions" label="Other Conditions"></chc-input>
              <chc-input v-model="data.title_state" :error="errors.title_state" label="State" format="combo"
                         :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
              <chc-input v-model="data.title_status" :error="errors.title_status" label="Title Status" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.title_status"></chc-input>
              <chc-input v-model="data.title_type" :error="errors.title_type" label="Title Type" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.title_type"></chc-input>

              <chc-input v-model="data.interior_intact" :error="errors.interior_intact" label="Interior intact?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.interior_intact"></chc-input>

              <chc-input v-model="data.flood_fire_damage_free" :error="errors.flood_fire_damage_free" label="Vehicle is free of flood or fire damage?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.flood_fire_damage_free"></chc-input>

              <chc-input v-model="data.engine_transmission_condition" :error="errors.engine_transmission_condition" label="Vehicle's engine and transmissions are intact, missing parts or removed?" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.engine_transmission_condition"></chc-input>

              <chc-input v-model="data.usage" :error="errors.usage" label="Vehicle Usage" format="combo"
                         :autoCompleteValues="$store.state.constants.vehicle.usage"></chc-input>
            </div>
          </div>
        </div>

        <span v-if="hasErrors" class="error-message">
          There were errors processing the form. Please fix the fields above.
        </span>

        <div class="field buttons left">
          <input @click.prevent="submit" :disabled="isLoading" readonly class="btn" value="Submit Donation">
        </div>

      </form>
    </section>
    <section v-if="state === 'submitted'" class="wrapper">
      <p><strong>Thank you for your donation!</strong></p>
      <p>Once your information is reviewed you will receive an email confirmation from our partner, Cars Helping Charities, and a towing company will contact you to set up a convenient time for pickup.</p>
    </section>
  </div>
</template>

<script>
import store from '@/store'
import VehicleFormMixin from '../Vehicle/VehicleFormMixin'

export default {
  name: 'DonationWidgetFullForm',
  mixins: [VehicleFormMixin],
  data () {
    return {
      charityId: null,
      data: {},
      errors: {},
      // form or submitted
      state: 'form',
      isLoading: false,
      loadingVin: false,
      currentVin: null,
      hasErrors: false,
      isLoadingSources: false,
      sources: [],
      hasLogo: false,
      charityName: null,

      gtag_id: null,
      analytics_params: [],
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.id) {
      let charityData = null
      let widgetData = {}
      Promise.all([
        store.dispatch('syncConstants'),
        store.dispatch('syncSummary'),
        store.functions.charity.getCharityFullForm(to.params.id, (response) => {
          charityData = response.data
        }),
        store.functions.charity.getCharityWidgetDetails(to.params.id, (response) => {
          widgetData = response.data
        })
      ]).then(() => next((vm) => vm.setData(to.query.data, charityData, to.params.token, widgetData)))
    } else {
      Promise.all([
        store.dispatch('syncConstants'),
        store.dispatch('syncSummary'),
      ]).then(() => next((vm) => {
        vm.setData(to.query.data, null, null)
      }))
    }
  },
  computed: {
    analyticsParamsObject () {
      let params = {}
      for (var i = this.analytics_params.length - 1; i >= 0; i--) {
        params[this.analytics_params[i].key] = this.analytics_params[i].value
      }
      return params
    }
  },
  mounted () {
  },
  watch: {
    state (val) {
      if (val === 'submitted') {
        this.sendGtag()
      }
    }
  },
  methods: {
    setData (data, charity, token, widgetData) {
      this.data = JSON.parse(data)
      this.currentVin = this.data.vin
      this.data.submit_website = decodeURIComponent(this.data.submit_website)
      if (charity) {
        this.data.charity_id = charity.id
        this.charityId = charity.id
        this.charityName = charity.name
        this.hasLogo = charity.logo
      }
      this.data.widget_token = token
      this.setColors(widgetData)
      this.setGtag(widgetData.gtag_id, widgetData.analytics_params)
      this.loadSources()
    },
    setColors (colors) {
      if (colors.accent_color) {
        this.$el.style.setProperty('--accent-color-widget', colors.accent_color)
      }
      if (colors.btn_color) {
        this.$el.style.setProperty('--btn-background-color-widget', colors.btn_color)
      }
      if (colors.btn_text) {
        this.$el.style.setProperty('--btn-text-color-widget', colors.btn_text)
      }
    },
    submit () {
      this.isLoading = true
      const dataForSubmission = this.cleanVehicleMultiSelectLocationData(this.data)
      store.functions.vehicles.createVehicle(dataForSubmission, (errors) => {
        this.errors = errors
        this.hasErrors = true
        this.isLoading = false
      }).then(() => {
        if (!this.charityName) {
          store.functions.charity.getCharityFullForm(this.data.charity_id, (response) => {
            let charity = response.data
            this.charityId = charity.id
            this.charityName = charity.name
            this.hasLogo = charity.logo
          }).catch(() => {
            this.state = 'submitted'
            this.data = {}
            this.isLoading = false
          }).then(() => {
            this.state = 'submitted'
            this.data = {}
            this.isLoading = false
          })
        } else {
          this.state = 'submitted'
          this.data = {}
          this.isLoading = false
        }
      })
    },
    loadSources (id) {
      if (isNaN(id)) return
      this.isLoadingSources = true
      this.data.referral_source_id = null
      store.functions.charity.getSources(id, (errors) => {
      }).then(response => {
        this.sources = response.data
      }).catch(() => {
      }).finally(() => {
        this.isLoadingSources = false
      })
    },
    pullVin () {
      if (this.data.vin === this.currentVin) return
      this.loadingVin = true
      store.functions.vehicles.vinInfo(this.data, (errors) => {
        this.loadingVin = false
      }).then((response) => {
        this.$refs.vehicleMake.forceUpdateValue(response.data.vehicle_make)
        this.$refs.vehicleModel.forceUpdateValue(response.data.vehicle_model)
        this.$refs.vehicleYear.forceUpdateValue(response.data.vehicle_year)
        this.$refs.vehicleColor.forceUpdateValue(response.data.vehicle_color)
        this.$refs.transmissionType.forceUpdateValue(response.data.transmission_type)
        this.$refs.driveTrain.forceUpdateValue(response.data.drive_train)
        this.$refs.bodyClass.forceUpdateValue(response.data.body_class)
        this.$refs.numDoors.forceUpdateValue(response.data.doors)
        this.currentVin = this.data.vin
        this.loadingVin = false
      }).catch(() => {
        this.$refs.vehicleMake.forceUpdateValue(null)
        this.$refs.vehicleModel.forceUpdateValue(null)
        this.$refs.vehicleYear.forceUpdateValue(null)
        this.$refs.vehicleColor.forceUpdateValue(null)
        this.$refs.transmissionType.forceUpdateValue(null)
        this.$refs.bodyClass.forceUpdateValue(null)
        this.$refs.numDoors.forceUpdateValue(null)
        this.loadingVin = false
      })
    },
    setGtag (id, params) {
      this.gtag_id = id
      this.analytics_params = params
      if (id) {
        window.dataLayer = window.dataLayer || []
        window.gtag = function () {
          window.dataLayer.push(arguments)
        }
        window.gtag('js', new Date())
        window.gtag('config', id)
      }
    },
    sendGtag () {
      if (this.gtag_id) {
        window.gtag('event', 'conversion', {'send-to': this.gtag_id})
      }
    },
  },
  props: {
  },
  components: {
  }
}
</script>

<style>
header {
  margin: 0;
  padding: 1rem;
  position: relative;
}
header .logo {
  display: block;
  max-width: 300px;
  max-height: 300px;
  margin: auto;
}
header .chc-logo {
  display: block;
  max-width: 250px;
  margin: auto;
}
header * {
  text-align: center;
}
</style>

<style lang="scss" scoped>
@import "../../style/_variables.scss";

.widget-long-form /deep/ .btn {
  text-align: center;
  color: var(--btn-text-color-widget);
  background: var(--btn-background-color-widget);
  &:disabled {
    background: #ced0d0;
  }
}

.widget-long-form /deep/ {
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="tel"],
  input[type="date"],
  input[type="number"],
  input[type="time"],
  textarea {

    &:focus {
      + .field-label {
        color: var(--accent-color-widget);
      }
      &.fixed + .field-label {
        color: var(--accent-color-widget);
      }
    }
    &.fixed {
      + .field-label {
        color: var(--accent-color-widget);
      }
    }
  }
  .date-field input[type="text"] {
    &:focus {
      ~ .field-label {
        color: var(--accent-color-widget);
      }
      &.fixed ~ .field-label {
        color: var(--accent-color-widget);
      }
    }
  }
  input[type="radio"] {
    &:checked + label::before {
        background-image: radial-gradient(circle, var(--accent-color-widget) 0%, var(--accent-color-widget) 35%, $lt-grey 35%, $lt-grey);
    }
  }
  .icon {
    &.fa-search,
    &.fa-calendar-alt,
    &.fa-times,
    &.fa-check {
      color: var(--accent-color-widget);
    }
  }
  .checkbox {
    input[type=checkbox] {
      &:checked+label:before {
        color: var(--accent-color-widget);
      }
    }
  }
  .tab-heading {
    color: $dark-grey;
    border-bottom: 3px solid var(--accent-color-widget);
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/DonationWidgetFullForm.vue